var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-service-item"},[(_vm.notification.active)?_c('Notification',{attrs:{"content":_vm.notification.content,"type":_vm.notification.type}}):_vm._e(),_c('ServicesListItemForm',{on:{"submit":_vm.updateListItem},model:{value:(_vm.listItem),callback:function ($$v) {_vm.listItem=$$v},expression:"listItem"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }